import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';
import React from 'react';
import {
	HelpIcon,
	HistoryIcon,
	MembershipIcon,
	PaymentIcon,
	ProfileIcon,
	SettingsIcon,
	ShippingIcon
} from '../../svg';

const StyledAccordionHeader = styled.div`
	padding-bottom: 12px;
	border-bottom: 1px solid #e3e3e3;
	${EmotionBreakpoint('mobile')} {
		h5 {
			font-size: 20px;
			line-height: 28px;
		}
		border: none;
	}
	svg {
		width: 32px;
		height: 32px;
	}
	.font-25 {
		font-size: 25px;
		line-height: 28px;
		letter-spacing: 0.25px;
	}
`;

function AccordionHeader({ title = '', faqData = '', privacyData = '' }) {
	const filteredRouteData = [...faqData, ...privacyData];

	function getHeaderIcon() {
		switch (title) {
			case 'wine-plans':
				return MembershipIcon;
			case 'delivery-and-returns':
				return ShippingIcon;
			case 'existing-orders':
				return HistoryIcon;
			case 'payments-and-vouchers':
				return PaymentIcon;
			case 'order-issues':
				return SettingsIcon;
			case 'my-account':
				return ProfileIcon;
			default:
				return HelpIcon;
		}
	}
	let HeaderIcon = getHeaderIcon();
	let accordionTitle = filteredRouteData?.filter((data) => data.slug === title);

	return (
		<StyledAccordionHeader className='d-flex align-items-center'>
			<HeaderIcon className='mr-18' />
			<h1 className='font-oswald lower mb-0 font-25'>
				{accordionTitle && accordionTitle[0]?.title}
			</h1>
		</StyledAccordionHeader>
	);
}

export default AccordionHeader;
